// Demo-only in-app membership plan change (the SDK doesn't carry it; mock billing only — the server
// gates it to no-Stripe environments). Same auth as the other patient calls: Cognito bearer +
// credentials:include. Persists the chosen tier to patients.tier server-side; the caller re-fetches
// the billing summary to reflect it.
import { useMemo } from "react";
import { API_ORIGIN } from "../config";
import { useAppAuth } from "../auth";

export type PlanTier = "basic" | "premium";

export function useBillingApi(): { selectPlan(tier: PlanTier): Promise<void> } {
  const { getToken } = useAppAuth();
  return useMemo(
    () => ({
      async selectPlan(tier: PlanTier) {
        const headers: Record<string, string> = { "Content-Type": "application/json" };
        const token = await getToken();
        if (token) headers["Authorization"] = `Bearer ${token}`;
        const res = await fetch(`${API_ORIGIN}/v1/patient/billing/select-plan`, {
          method: "POST",
          headers,
          credentials: "include",
          body: JSON.stringify({ tier }),
        });
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          let message: string | undefined;
          try {
            message = (JSON.parse(text) as { error?: { message?: string } }).error?.message;
          } catch {
            /* non-JSON body */
          }
          throw new Error(message ?? "Could not change your plan. Please try again.");
        }
      },
    }),
    [getToken],
  );
}
